@switch (type()) {
    @case (buildingType.Marketplace) {
        <svg:path
            d="M108 530 L310 405 V381 L108 502 L108 530 Z"
            fill="var(--base-border-bg-1)" />
        <svg:path
            d="M108 530 L310 410 V385 L108 505 L108 530 Z"
            fill="var(--wall-bg-2)" />

        <svg:path
            d="M0 461 L108 530 L108 502 L0 437 V461 Z"
            fill="var(--base-border-bg-1)" />
        <svg:path
            d="M0 466 L108 530 L108 505 L0 440 V466 Z"
            fill="var(--wall-bg-1)" />
    }

    @case (buildingType.Monitoring_Reporting) {
        <svg:path
            d="M1 251 L178 356 L178 353 L0 248 Z"
            fill="var(--base-border-bg-1)" />

        <svg:path
            d="M178 356 L300 285 L300 282 L178 353 Z"
            fill="var(--base-border-bg-1)" />
    }

    @case (buildingType.Library) {
        <!-- Pillar 1 -->
        <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        [attr.d]="'M38.44 ' + height() + ' L19.69 ' + (height() + 10) + ' V122.01 L38.44 111.65 Z'"
        fill="var(--wall-bg-2)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        [attr.d]="'M19.69 ' + (height() + 10) + ' L0.96 ' + height() + ' V111.65 L19.69 122.01 Z'"
        fill="var(--wall-bg-1)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        d="M19.6866 123.4563L39.0244 112.7135L20.291 101.834L0.361816 112.7381L19.6866 123.4563Z"
        fill="var(--roof-box-bg-1)" />
    

        <!-- Pillar 2 -->
        <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        [attr.d]="'M169.887 ' + (height() + 70) + ' L151.16 ' + (height() + 80) + ' V195.873 L169.887 185.469 Z'"
        fill="var(--wall-bg-2)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        [attr.d]="'M151.161 ' + (height() + 80) + ' L131.823 ' + (height() + 70) + ' V187.079 L151.161 197.782 Z'"
        fill="var(--wall-bg-1)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        d="M151.2 197.3 L170.5 186.5 L151.8 175.7 L131.8 186.5 L151.2 197.3 Z"
        fill="var(--roof-box-bg-1)" />
    

        <!-- Pillar 3 -->
        <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        [attr.d]="'M347.5 ' + (height() - 30) + ' L328.155 ' + (height() - 20) + ' V94.1797 L347.5 83.4839 Z'"
        fill="var(--wall-bg-2)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        [attr.d]="'M328.155 ' + (height() - 20) + ' L308.796 ' + (height() - 30) + ' V83.4839 L328.155 94.2043 Z'"
        fill="var(--wall-bg-1)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        d="M328.155 95.2043 L347.5 84.4839 L328.745 73.5864 L308.796 84.4839 L328.155 95.2043Z"
        fill="var(--roof-box-bg-1)" />
    

        <!-- Base -->
        <svg:path
        d="M151.193 457.392L347.421 343.52V318.961L151.182 429.833L151.193 457.392Z"
        fill="var(--base-border-bg-1)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        d="M151.193 457.392L347.421 348.389V327.094L151.182 437.977L151.193 457.392Z"
        fill="var(--wall-bg-2)" />
    <svg:path
        d="M0.9316 371.349L151.193 457.393L151.189 429.914L0.9316 346.783V371.349Z"
        fill="var(--base-border-bg-2)" />
    <svg:path
        stroke="url(#paint6_linear_7217_69040)"
        d="M0.9316 376.206L151.193 457.392L151.189 438.064L0.9316 354.929V376.206Z"
        fill="var(--wall-bg-1)" />
    
    }
}
